import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const EvaluacionesMedicasDelete = ({
  id,
  name,
  mostrarAlertaTemporal,
  obtenerEvaluaciones,
  id_candidato,
  onClose,
  estado,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const prefijoDeModal = name === "rrhh" ? "la" : "el" //Cambia por "la" o "el" dependiendo si es rrhh o medico

  const interviewStatusUpdate = async () => {
    try {
      const campo = `aprobado_parte_${name}`;
      const response = await fetch(`${UrlApi}/SP_evaluaciones/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        // [campo]  ===>  aprbado_parte_? => medico/rrhh
        body: JSON.stringify({ [campo]: estado }),
      });

      if (!response.ok) {
        mostrarAlertaTemporal(
          `Hubo un error al cambiar el estado de la parte ${name}`,
          "error"
        );
      }
      mostrarAlertaTemporal(
        `El estado de la parte ${name} se actualizo correctamente`,
        "success"
      );

      await obtenerEvaluaciones();
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    try {
      const response = await fetch(
        `${UrlApi}/SP_candidatos/verificarAptitud/${id_candidato}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        mostrarAlertaTemporal(
          `Hubo un error al actualizar el estado del candidato`,
          "error"
        );
      }
      mostrarAlertaTemporal(
        `El estado del candidato se actualizo correctamente`,
        "success"
      );
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    if (name === "medico") {
      try {
        const response = await fetch(
          `${UrlApi}/SP_candidatos/${id_candidato}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ evaluacion_evaluada: 0 }),
          }
        );

        if (!response.ok) {
          throw new Error(`Error en la petición`);
        }

        console.log("Evaluación marcada como vista");
      } catch (error) {
        console.error("Error al actualizar la evaluación:", error);
      }
    }

    logEventos(
      `Aprobando/Desaprobando parte ${name}`,
      `Parte ${name}`,
      `Cambiando el estado de la parte ${name} de las evaluaciones medicas`,
      localStorage.getItem("user")
    );

    onClose();
  };
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {estado === 1
                ? `Aprobar ${prefijoDeModal} parte ${name}`
                : `Desaprobar ${prefijoDeModal} parte ${name}`}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>

          {estado === 1
            ? `¿Esta seguro que quiere aprobar ${prefijoDeModal} parte ${name}?`
            : `¿Esta seguro que quiere desaprobar ${prefijoDeModal} parte ${name}?`}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={interviewStatusUpdate}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default EvaluacionesMedicasDelete;
